<template>
  <div class="filter">
    <div class="filter__search">
      <Entry
        v-model="inputValue"
        :indicator="indicator"
        returnKeyEvent
        :doManageEntry="false"
        @entry:keyUp='emitSearch' />
    </div>
  </div>
</template>

<script>

import Entry from '../components/Entry'

export default {
  data: function () {
    return {
      timeOutPointer: undefined,
      oldSearch: '',
      inputValue: ''
    }
  },
  components: {
    Entry
  },

  props: {
    indicator: String,
    regEx: Object
  },
  methods: {
    emitSearch (event) {
      clearTimeout(this.timeout)

      const searchStr = event.target.value
      if (searchStr.length >= 2 || (searchStr.length < this.oldSearch.length) || event.keyCode === 13) {
        // Debounce
        this.timeout = setTimeout(() => {
          let rep = []
          if (Object.keys(this.regEx).length) {
            Object.keys(this.regEx).forEach(k => {
              switch (k) {
                case 'or':
                  for (let kor in this.regEx[k]) {
                    if (this.regEx[k][kor].test(searchStr)) {
                      rep.push(`or[]={"${kor}":"${searchStr}"}`)
                    }
                  }
                  break
                default:
                  if (this.regEx[k].test(searchStr)) {
                    rep.push(`${k}=${searchStr}`)
                  }
                  break
              }
            })
          } else {
            rep.push(searchStr)
          }
          this.$emit(`update:filter`, rep.join('&'))
        }, event.keyCode === 13 ? 200 : 1000)
        this.oldSearch = searchStr
      }
    }
  }
}
</script>
